import { render } from "./PolicyGuidePage.vue?vue&type=template&id=49ae9b65"
const script = {}

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__